import { Navigate, useLocation } from 'react-router-dom';
import { useMe } from '../hooks/useAuth.js';

interface Props {
  children: React.ReactNode;
  /** Pass true on the Welcome page itself so we don't bounce-loop. */
  allowUnonboarded?: boolean;
}

export function RequireAuth({ children, allowUnonboarded }: Props) {
  const { data, isLoading } = useMe();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="mx-auto max-w-md px-4 py-24 text-center text-navy-500">Loading…</div>
    );
  }
  if (!data?.user) {
    return (
      <Navigate
        to={`/login?next=${encodeURIComponent(location.pathname + location.search)}`}
        replace
      />
    );
  }
  if (!allowUnonboarded && !data.user.onboardedAt) {
    return (
      <Navigate
        to={`/welcome?next=${encodeURIComponent(location.pathname + location.search)}`}
        replace
      />
    );
  }
  return <>{children}</>;
}
